import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PersonState = CommonTableState;

const initialState: PersonState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "lastName", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            dataBox: false,
            created: false,
            creator: false,
        },
        columnOrder: ["id", "email", "phone", "dataBox", "creator", "created", "mrt-row-actions"],
        density: "compact",
    },
};

export const personSlice = createSlice({
    name: "person",
    initialState: initialState,
    reducers: {
        updatePersonTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updatePersonTableState} = personSlice.actions;

export default personSlice.reducer;
